"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextViewer = exports.LayoutControlsPanel = exports.CommonControlsSectionHeader = exports.ApplicationWorkflowNoteAction = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var player_rich_text_viewer_1 = require("player-rich-text-viewer");
exports.RichTextViewer = player_rich_text_viewer_1.default;
var ApplicationWorkflowNoteAction = (function (_super) {
    __extends(ApplicationWorkflowNoteAction, _super);
    function ApplicationWorkflowNoteAction(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowNoteAction.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationWorkflowNoteAction.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationWorkflowNoteAction.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationWorkflowNoteAction.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationWorkflowNoteAction.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationWorkflowNoteAction.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowNoteAction.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowNoteAction.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowNoteAction.prototype.render = function () {
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(SectionHeader_1.SectionHeader, { key: 0, size: "H2", text: $this.state.viewModel.actionItem.title, tag: $this.state.viewModel.parentTag }), React.createElement(Panel_1.Panel, { key: 1, paddingVertical: "Small", children: [React.createElement(player_rich_text_viewer_1.default, { key: 0, html: $this.state.viewModel.actionItem.instructions, allowedTags: $this.state.viewModel.constants.PRTV_ALLOWED_TAGS, allowedAttributes: $this.state.viewModel.constants.PRTV_ALLOWED_ATTRIBUTES })] }), React.createElement(player_rich_text_viewer_1.default, { key: 2, html: $this.state.viewModel.actionItem.note, allowedTags: $this.state.viewModel.constants.PRTV_ALLOWED_TAGS, allowedAttributes: $this.state.viewModel.constants.PRTV_ALLOWED_ATTRIBUTES })];
        };
        return (React.createElement("div", { className: "p-view-applicationworkflownoteaction" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationWorkflowNoteAction.defaultProps = {
        actionItem: "",
        onDataChanged: function () { }
    };
    return ApplicationWorkflowNoteAction;
}(React.Component));
exports.ApplicationWorkflowNoteAction = ApplicationWorkflowNoteAction;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowNoteAction"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowNoteAction/ApplicationWorkflowNoteAction.js
// module id = 578
// module chunks = 0